export default "__VITE_ASSET__ChIdmzow__"